module.exports = __webpack_public_path__ + "media/jiangsu.1d856983.mp4";